import { ProposalJobDescriptionBreakDownMode } from '@anytag/graphql';
import { ProposeInfluencersFormValues } from '../../Influencers';
import { PackageProposedInfluencer, RowPackageData, RowPackageInfluencerData } from './PackageContentList/types';

export const formatPackageProposedInfluencersRowsData = (
  influencers: PackageProposedInfluencer[],
  jdMode?: ProposalJobDescriptionBreakDownMode,
  isEditMode = false
) =>
  influencers.reduce<{ tableData: RowPackageData[]; formValues: ProposeInfluencersFormValues }>(
    (acc, { accountList, ...influencer }) => {
      const currentIndex = acc.tableData.length;
      const hasSocialAccount = jdMode === ProposalJobDescriptionBreakDownMode.SOCIAL_BREAKDOWN && !!accountList;
      const influencerData: RowPackageInfluencerData = {
        id: influencer.id,
        name: influencer.name,
        status: influencer.status,
        avatar: influencer.avatar
      };
      const influencerEditableFields = {
        budget: influencer.budget || 0,
        profit: influencer.profit || 0,
        influencerCost: influencer.influencerCost || 0
      };
      acc.tableData.push({
        index: currentIndex,
        className: 'influencer-row',
        influencer: influencerData,
        isEditable: jdMode === ProposalJobDescriptionBreakDownMode.INFLUENCER_BREAKDOWN && isEditMode,
        stats: {
          ...influencerEditableFields,
          engagementRateByViews: influencer.engagementViewRate,
          engagementRateByFollowers: influencer.engagementFollowerRate,
          followersCount: influencer.followersCount,
          addedDate: influencer.addedDate,
          engagementPosted: influencer.engagementPostedCount,
          engagementProposed: influencer.engagementProposedCount
        }
      });
      acc.formValues[`${currentIndex}-budget`] = influencerEditableFields.budget.toString();
      acc.formValues[`${currentIndex}-profit`] = influencerEditableFields.profit.toString();
      acc.formValues[`${currentIndex}-influencerCost`] = influencerEditableFields.influencerCost.toString();

      if (hasSocialAccount) {
        accountList.forEach(({ id: accId, name: accName, socialMedia: accSm, summary, addedDate }, index) => {
          const accountIndex = acc.tableData.length;
          const accountEditableFields = {
            budget: summary.budget || 0,
            profit: summary.profit || 0,
            influencerCost: summary.influencerCost || 0
          };
          acc.tableData.push({
            isEditable: isEditMode,
            className: 'account-row',
            index: accountIndex,
            influencer: influencerData,
            socialAccount: {
              id: accId,
              name: accName,
              socialMedia: accSm,
              lastIndex: index === accountList.length - 1
            },
            stats: {
              ...accountEditableFields,
              engagementRateByViews: summary.engagementViewRate,
              engagementRateByFollowers: summary.engagementFollowerRate,
              followersCount: summary.followersCount,
              addedDate,
              engagementPosted: summary.engagementPostedCount,
              engagementProposed: summary.engagementProposedCount
            }
          });
          acc.formValues[`${accountIndex}-budget`] = accountEditableFields.budget.toString();
          acc.formValues[`${accountIndex}-profit`] = accountEditableFields.profit.toString();
          acc.formValues[`${accountIndex}-influencerCost`] = accountEditableFields.influencerCost.toString();
        });
      }

      return acc;
    },
    { tableData: [], formValues: {} }
  );
